module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"Discover MyMove IoT Platform! Explore new features and an all-new design.","learnMoreLinkText":"Learn more","tryNowButtonText":"TRY NOW"},"it":{"text":"Scopri MyMove IoT Platform! Esplora le nuove funzionalità e un design tutto nuovo.","learnMoreLinkText":"Scopri di più","tryNowButtonText":"PROVA SUBITO"}}')
  delete Component.options._Ctor
}
